<template>
  <div v-bind="$attrs">
    <input
      :id="id"
      :name="name"
      type="checkbox"
      :checked="state"
      :value="value"
      :disabled="disabled"
      @change="change"
    />
    <label :for="id">{{ label }}</label>
  </div>
</template>

<script>
export default {
  name: 'TkCheckbox',
  model: {
    prop: 'selected',
  },
  props: {
    selected: {
      type: [Array, Boolean],
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      default: null,
    },
    id: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number],
      default: null,
    },
  },
  computed: {
    state() {
      if (Array.isArray(this.selected)) {
        return this.selected.includes(this.value)
      }
      return this.selected
    },
  },
  methods: {
    change($event) {
      if (Array.isArray(this.selected)) {
        let selected = [...this.selected]
        const value = this.value
        if (selected.includes(value)) {
          selected = selected.filter((value) => value !== this.value)
        } else {
          selected.push(value)
        }
        this.$emit('input', selected)
        return
      }
      this.$emit('input', $event.target.checked)
    },
  },
}
</script>
